module.exports = __webpack_public_path__ + "static/media/sneridaghLogo.058c39e4.png";